import React, { PropTypes, Component } from 'react'
// moment
import moment from 'moment'
moment.locale('es')
// css
import style from './Dashboard.css'
import * as ReactNotifyCSS from '../../shared/ReactNotify/ReactNotify.css'
// modal
import Modal from 'react-bootstrap/lib/Modal.js'
// notify
import ReactNotify from 'react-notify'
// service
import homeService from '../services/homeService'
// components
import { PanelIndicators } from '../components/managementIndicators/PanelIndicators.jsx'
import ModalActa from '../components/ModalActa.jsx'
import ModalActaCliente from '../components/ModalActaCliente.jsx'
import ModalImagenes from '../components/ModalImagenes.jsx'
import ModalChecklist from '../components/ModalChecklist.jsx'
import ReporteRuta from '../../auditorias/programacion-semanal/ReporteRuta.jsx'
import ModalInventarios from '../components/ModalInventarios.jsx'

export class Dashboard extends Component {
    constructor(props) {
        super(props)
        this.state = {
            indicators: [],
            summaryIndicatorsRange: [],
            summaryIndicatorsMonth: [],
            summaryIndicatorsYear: [],
            idClient: this.props.idClient,
            dateIndicator: moment(new Date(this.props.dateIndicator)),
            showModalStockLoad: this.props.stockPending,
            fechaInicialSeleccionada: moment().subtract(1, 'days'),
            fechaFinalSeleccionada: moment().endOf('week'),
            sinFiltro: true,
            showModalActa: false,
            showModalActaCliente: false,
            showModalImagenes: false,
            showModalChecklist: false,
            invActa: "",
            dataActa: [],
            today: moment(new Date()),
            showArriendo: this.props.perms.permDBS,
            cargandoMes: false,
            cargandoYear: false,
            cargandoData: false,
        };
        this.openModalActa = (idInventario) => {
            this.setState({
                showModalActa: true,
                invActa: idInventario
            })
        }

        this.openModalActaCliente = (idInventario) => {
            this.setState({
                showModalActaCliente: true,
                invActa: idInventario
            })
        }

        this.openModalImagenes = (idInventario) => {
            this.setState({
                showModalImagenes: true,
                invActa: idInventario
            })
        }

        this.openModalChecklist = (idInventario) => {
            this.setState({
                showModalChecklist: true,
                invActa: idInventario
            })
        }

        this.setFiltro = (filtros, bool = false) => {
            const clientes = filtros.map(f => {
                return f.client_name
            })
            const clientesUnicos = clientes.filter((item, i, ar) => ar.indexOf(item) === i)
            if (bool) {
                this.fetchIndicators()
                this.fetchSummaryIndicatorsMonth()
                this.fetchSummaryIndicatorsYear()
            } else if (filtros.length > 0) {
                this.summaryFiltros(clientesUnicos)
                this.summaryFiltrosMonth(clientesUnicos)
                this.summaryFiltrosYear(clientesUnicos)
                this.setState({ sinFiltro: false })
            }
        }

        this.summaryFiltros = (clientes) => {
            const { dateIndicator } = this.state
            homeService.client.indicators.getManagementIndicators(clientes, dateIndicator.format('YYYY-MM-DD'), dateIndicator.format('YYYY-MM-DD'))
                .then(response => {
                    this.setState({
                        summaryIndicatorsRange: response.summaryIndicators
                    })
                })
                .catch(error => console.log(error))
        };

        this.summaryFiltrosMonth = (clientes) => {
            const { dateIndicator } = this.state
            this.setState({cargandoMes: true})
            homeService.client.indicators.getSummaryIndicatorsPeriod(clientes, dateIndicator.format('YYYY-MM-DD'), false)
                .then(summaryIndicatorsMonth => {
                    this.setState({ summaryIndicatorsMonth, cargandoMes: false })
                })
                .catch(error => console.log(error))
        };

        this.summaryFiltrosYear = (clientes) => {
            const { dateIndicator } = this.state
            this.setState({cargandoYear: true})
            homeService.client.indicators.getSummaryIndicatorsPeriod(clientes, dateIndicator.format('YYYY-00-00'), true)
                .then(summaryIndicatorsYear => {
                    this.setState({ summaryIndicatorsYear, cargandoYear: false })
                })
                .catch(error => console.log(error))
        };

        this.fetchIndicators = () => {
            const { idClient, dateIndicator } = this.state
            this.setState({ cargandoData: true })
            homeService.client.indicators.getManagementIndicators(idClient, dateIndicator.format('YYYY-MM-DD'), dateIndicator.format('YYYY-MM-DD'))
                .then(response => {
                    this.setState({
                        indicators: response.indicatorsResource,
                        summaryIndicatorsRange: response.summaryIndicators,
                        cargandoData: false
                    })
                })
                .catch(error => console.log(error))
        };

        this.fetchSummaryIndicatorsMonth = () => {
            const { idClient, dateIndicator } = this.state
            this.setState({cargandoMes: true})
            homeService.client.indicators.getSummaryIndicatorsPeriod(idClient, dateIndicator.format('YYYY-MM-DD'), false)
                .then(summaryIndicatorsMonth => {
                    this.setState({ summaryIndicatorsMonth, cargandoMes: false })
                })
                .catch(error => console.log(error))
        };

        this.fetchSummaryIndicatorsYear = () => {
            const { idClient, dateIndicator } = this.state
            this.setState({cargandoYear: true})
            homeService.client.indicators.getSummaryIndicatorsPeriod(idClient, dateIndicator.format('YYYY-MM-DD'), true)
                .then(summaryIndicatorsYear => {
                    this.setState({ summaryIndicatorsYear, cargandoYear: false })
                })
                .catch(error => console.log(error))
        };

        this.getStats = () => {
            const { idClient, dateIndicator } = this.state
            //this.setState({ cargandoData: true })
            homeService.client.indicators.getStats(idClient, dateIndicator.format('YYYY-MM-DD'), dateIndicator.format('YYYY-MM-DD'))
                .then(response => {
                    this.setState(prevState => {
                        const indicatorsActualizados = prevState.indicators.map(indicator => {
                            const nuevoAvance = response.find(a => a.idInventario === indicator.inv);
                            if (nuevoAvance) {
                                return { ...indicator, avance: nuevoAvance };
                            }
                            return indicator;
                        });
                        return {
                            indicators: indicatorsActualizados,
                            cargandoData: false
                        };
                    });
                })
                .catch(error => console.log(error))
        };

        this.cancelModalStockLoad = () => {
            this.setState({ showModalStockLoad: false })
        };

        this.cancelModalArriendo = () => {
            this.setState({ showArriendo: false })
        };

        this.cancelModalActa = () => {
            this.setState({
                showModalActa: false,
                invActa: "",
                dataActa: []
            })
        }

        this.cancelModalActaCliente = () => {
            this.setState({
                showModalActaCliente: false,
                invActa: "",
                dataActa: []
            })
        }

        this.cancelModalImagenes = () => {
            this.setState({
                showModalImagenes: false,
                invActa: "",
                dataActa: []
            })
        }

        this.cancelModalChecklist= () => {
            this.setState({
                showModalChecklist: false,
                invActa: "",
                dataActa: []
            })
        }

        this.dayBefore = () => {
            const { dateIndicator, today } = this.state
            this.setState({
                sinFiltro: true,
                dateIndicator: dateIndicator.add(1, 'days')
            }, () => {
                this.fetchIndicators();
                this.fetchSummaryIndicatorsMonth();
                this.fetchSummaryIndicatorsYear();
                // if (dateIndicator.format('M') != today.format('M')) {
                //     this.fetchSummaryIndicatorsMonth();
                // }
                // if (dateIndicator.format('YYYY') != today.format('YYYY')) {
                //     this.fetchSummaryIndicatorsYear();
                // }
            })

        };

        this.dayAfter = () => {
            const { dateIndicator, today } = this.state
            this.setState({
                sinFiltro: true,
                dateIndicator: dateIndicator.subtract(1, 'days')
            }, () => {
                this.fetchIndicators();
                this.fetchSummaryIndicatorsMonth();
                this.fetchSummaryIndicatorsYear();
                // if (dateIndicator.format('M') != today.format('M')) {
                //     this.fetchSummaryIndicatorsMonth();
                // }
                // if (dateIndicator.format('YYYY') != today.format('YYYY')) {
                //     this.fetchSummaryIndicatorsYear();
                // }
            })
        };

        this.selectDay = (e) => {
            const { dateIndicator, today } = this.state
            this.setState({
                sinFiltro: true,
                dateIndicator: moment(new Date(e.target.value + "T00:00:00"))
            }, () => {
                this.fetchIndicators()
                this.fetchSummaryIndicatorsMonth();
                this.fetchSummaryIndicatorsYear();
                // if (dateIndicator.format('M') != today.format('M')) {
                //     this.fetchSummaryIndicatorsMonth();
                // }
                // if (dateIndicator.format('YYYY') != today.format('YYYY')) {
                //     this.fetchSummaryIndicatorsYear();
                // }
            })
        }

        this.showNotifyStock = () => {
            if (this.props.stockPending)
                this.refs.notificator.error("Carga de stock", "Atención debe cargar stock teóricos de locales", 4 * 2000);
        };

        this.previewActa = (inventario) => {
            //console.log(inventario)
            homeService.acta.indicators.getActaPreview(inventario)
                .then(dataActa => {
                    this.setState({ dataActa })
                })
                .catch(error => console.log(error))
        }

        this.verActa = (inventario) => {
            homeService.acta.indicators.showActa(inventario)
                .then(dataActa => {
                    this.setState({ dataActa })
                })
                .catch(error => console.log(error))
        }

        this.get_Imagenes = (inventario) => {
            homeService.acta.indicators.getImagenes(inventario)
                .then(dataActa => {
                    this.setState({ dataActa })
                })
                .catch(error => console.log(error))
        }

        this.get_Checklist = (inventario) => {
            homeService.acta.indicators.getChecklist(inventario)
                .then(dataActa => {
                    this.setState({ dataActa })
                })
                .catch(error => console.log(error))
        }
    }

    componentDidMount() {
        if(this.props.perms.showManagementIndicators == true){
            this.fetchSummaryIndicatorsMonth();
            this.fetchSummaryIndicatorsYear();
        }
        //this.showNotifyStock();
    }
    
    render() {
        const { showModalStockLoad, dateIndicator, idClient, indicators, summaryIndicatorsRange, summaryIndicatorsMonth, summaryIndicatorsYear, showModalActa, invActa, dataActa, today, showArriendo, showModalActaCliente, showModalImagenes, showModalChecklist, cargandoMes, cargandoYear, cargandoData } = this.state
        return (
            <div className={`container-fluid ${style.Dashboard_container}`}>
                <ReactNotify ref='notificator' className={ReactNotifyCSS} />
                {this.props.perms.reporte_ruta &&
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-end', alignItems: 'end', height: '10px', marginTop: '15px' }}>
                        <ModalInventarios hoy={today} />
                        <ReporteRuta fechaInicio={today} />
                    </div>}
                {this.props.perms.showStockUpdateModal ?
                    <ModalStockLoad
                        showModal={showModalStockLoad}
                        cancelModal={this.cancelModalStockLoad}
                    /> : null
                }
                {/* {this.props.perms.permDBS ? 
                    <ModalArriendoDBS
                        showModal={showArriendo}
                        cancelModal={this.cancelModalArriendo}
                    /> : null} */}
                {showModalActa ? <ModalActa
                    showModal={showModalActa}
                    cancelModal={this.cancelModalActa}
                    previewActa={this.previewActa}
                    idInventario={invActa}
                    indicators={dataActa}
                /> : null}
                {showModalActaCliente ? <ModalActaCliente
                    showModal={showModalActaCliente}
                    cancelModal={this.cancelModalActaCliente}
                    previewActa={this.verActa}
                    idInventario={invActa}
                    indicators={dataActa}
                    id_file={indicators}
                /> : null}
                {showModalImagenes ? <ModalImagenes
                    showModal={showModalImagenes}
                    cancelModal={this.cancelModalImagenes}
                    imagenes={this.get_Imagenes}
                    idInventario={invActa}
                    indicators={dataActa}
                    id_file={indicators}
                /> : null}
                {showModalChecklist ? <ModalChecklist
                    showModal={showModalChecklist}
                    cancelModal={this.cancelModalChecklist}
                    checklist={this.get_Checklist}
                    idInventario={invActa}
                    indicators={dataActa}
                    id_file={indicators}
                /> : null}
                {this.props.perms.showManagementIndicators ?
                    <PanelIndicators
                        fetchIndicators={this.fetchIndicators}
                        getStats={this.getStats}
                        day={this.state.dateIndicator}
                        dateTitle={dateIndicator.format('LL')}
                        dateDay={dateIndicator.format('dddd')}
                        dateInit={dateIndicator.format('YYYY-MM-DD')}
                        dateYear={dateIndicator.format('YYYY-00-00')}
                        idClient={idClient}
                        indicators={indicators}
                        summaryIndicatorsRange={summaryIndicatorsRange}
                        summaryIndicatorsMonth={summaryIndicatorsMonth}
                        summaryIndicatorsYear={summaryIndicatorsYear}
                        dayBefore={this.dayBefore}
                        dayAfter={this.dayAfter}
                        selectDay={this.selectDay}
                        showOtherData={this.props.perms.showOtherData}
                        permissions={this.props.perms.dashboardSEI}
                        desvio={this.props.perms.desvio}
                        perms={this.props.perms}
                        fcv={this.props.perms.permFCV}
                        reportar={this.props.perms.reportar}
                        comentarioDashboard={this.props.perms.comentarioDashboard}
                        setFiltro={this.setFiltro.bind(this)}
                        sinFiltro={this.state.sinFiltro}
                        openModalActa={this.openModalActa.bind(this)}
                        openModalActaCliente={this.openModalActaCliente.bind(this)}
                        openModalImagenes={this.openModalImagenes.bind(this)}
                        openModalChecklist={this.openModalChecklist.bind(this)}
                        admin={this.props.perms.admin}
                        cargandoMes={cargandoMes}
                        cargandoYear={cargandoYear}
                        cargandoData={cargandoData}
                    //allFilters={this.allFilters.bind(this)}
                    /> : null
                }
            </div>
        )
    }
}

Dashboard.propTypes = {
    dateIndicator: PropTypes.string.isRequired,
    stockPending: PropTypes.bool.isRequired,
    idClient: PropTypes.string.isRequired,
    perms: PropTypes.object.isRequired
}

const ModalStockLoad = ({ showModal, cancelModal }) => (
    <Modal show={showModal} onHide={cancelModal}>
        <Modal.Header closeButton>
            <Modal.Title>Carga stock de locales</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h4>Le recordamos que debe actualizar el stock de locales.</h4>
        </Modal.Body>
        <Modal.Footer>
            <a className="btn btn-success" href={`/admin/actualizar-stock`} target="_blank">
                Ir ahora
            </a>
            <button type="button" className="btn btn-warning" onClick={cancelModal}>
                Ahora no
            </button>
        </Modal.Footer>
    </Modal>
)

const ModalArriendoDBS = ({ showModal, cancelModal }) => (
    <Modal show={showModal} onHide={cancelModal}>
        <Modal.Header closeButton>
            <Modal.Title>Arriendo de Equipos</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <h4>Le recordamos que esta semana tiene arriendo de equipos.</h4>
        </Modal.Body>
        <Modal.Footer>
            <a className="btn btn-success" href={`/arriendo-equipos/dbs/cliente`} target="_blank">
                Ir ahora
            </a>
            <button type="button" className="btn btn-warning" onClick={cancelModal}>
                Ahora no
            </button>
        </Modal.Footer>
    </Modal>
)

/*const ModalActa = ({ showModal, cancelModal }) => (
    <Modal show={true} onHide={cancelModal}>
        <Modal.Header closeButton>
            <Modal.Title>Acta Inventario IG</Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <div className="container" style={{ width: 'auto' }}>
                <div className="row">
                    <div >
                        <div id="accordion">
                            <div className="card">
                                <div className="card-header" id="headingOne">
                                    <button className="btn btn-link" data-toggle="collapse" data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne">
                                        Resumen Inventario
                                    </button>
                                </div>
                                <div id="collapseOne" className="collapse in" aria-labelledby="headingOne" data-parent="#accordion">
                                    <div className="card-body">
                                        <div className="panel-body">
                                            <ul className="list-group">
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Cliente
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>FARMACIA CRUZ VERDE</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Local (CECO)
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>261</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Fecha IG
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Dotación Presupuestada
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Dotación Efectiva
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Hora LLegada
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Supervisor SEI
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-6'>
                                                            Químico Farmacéutico
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingTwo">
                                    <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                        Horarios
                                    </button>
                                </div>
                                <div id="collapseTwo" className="collapse" aria-labelledby="headingTwo" data-parent="#accordion">
                                    <div className="card-body">
                                        <div className="panel-body">
                                            <ul className="list-group">
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>

                                                        </label>
                                                        <label style={{ width: '100px' }}>FECHA</label>
                                                        <label className='pull-right'>HORA</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Inicio Conteo
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>08:54</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Fin Conteo
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Horas Conteo
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}></label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Inicio Revisión Grilla
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Fin Proceso
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Horas Revisión
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}></label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Total Horas Inventario
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}></label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Validación Código Grilla
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}></label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '250px' }}>
                                                            Inicio Auditoria
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>07/08/2023</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingThree">
                                    <h5 className="mb-0">
                                        <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            Indicadores de Gestión de Inventario
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseThree" className="collapse" aria-labelledby="headingThree" data-parent="#accordion">
                                    <div className="card-body">
                                        <div className="panel-body">
                                            <ul className="list-group">
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Unidades Teóricas (Mapro Inicial)
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>13.960</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Unidades Físicas Inventariadas (Mapro Final)
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>14.120</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Unidades Diferencia Neta
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>160</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Unidades Diferencia Absoluto
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>469</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Inventario Teórico Valorizado
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>150.301.505</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Inventario Físico Valorizado
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>150.584.055</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Diferencia de Inventario Valorizada
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>282.550</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Total SKU (Códigos internos) efectivos local
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>4.223</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Total Items inventariados (escaneos)
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>5.179</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Cantidad PTT Inventariadas
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>564</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Cantidad PTT Nulas
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>0</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Total Unidades No Inventariables
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>0</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label className='col-md-9'>
                                                            Total Valorizado No Inventariables
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>65.950</label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="card">
                                <div className="card-header" id="headingFour">
                                    <h5 className="mb-0">
                                        <button className="btn btn-link collapsed" data-toggle="collapse" data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                            Indicadores de Auditoría Cliente
                                        </button>
                                    </h5>
                                </div>
                                <div id="collapseFour" className="collapse" aria-labelledby="headingFour" data-parent="#accordion">
                                    <div className="card-body">
                                        <div className="panel-body">
                                            <ul className="list-group">
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>

                                                        </label>
                                                        <label style={{ width: '100px' }}>Cantidad</label>
                                                        <label className='pull-right'>%</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            Cantidad de Items AUDITADOS Cliente
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>2.158</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>42.80</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            Cantidad de Patentes Auditadas Cliente
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>231</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>hola</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            Total unidades NETO corregidas AUDITORIA
                                                        </label>
                                                        <label style={{ fontWeight: 'normal', textAlign: 'left' }}>-2</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            Total unidades ABS corregidas AUDITORIA
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>8</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            Total ITEMS Corregidos AUDITORIAS (% Error SEI)
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>1</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            Total ITEMS Corregidos AUDITORIAS (% Error QF CV)
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>7</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>5.10</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            % Variacion Ajuste Neto (Grilla)
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}></label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.10</label>
                                                    </div>
                                                </li>
                                                <li className="list-group-item">
                                                    <div>
                                                        <label style={{ width: '380px' }}>
                                                            % Summary
                                                        </label>
                                                        <label style={{ fontWeight: 'normal' }}>0</label>
                                                        <label className='pull-right' style={{ fontWeight: 'normal' }}>0.00</label>
                                                    </div>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </Modal.Body>
    </Modal>
)*/


// WEBPACK FOOTER //
// ./frontEnd/home/containers/Dashboard.jsx